import * as React from 'react';
import Box from '@mui/material/Box';
import Draggable from 'react-draggable';
import {
    PIN_INNER_CIRCLE_RADIUS,
    PIN_PATH,
    PIN_STROKE_WIDTH,
    PIN_VIEWBOX_HEIGHT,
    PIN_VIEWBOX_WIDTH,
    Point,
    Size,
    pinDragBounds
} from '../state/utils';

type PinImagePreviewProps = {
    src: string;
    alt: string;
    imageSize: Size;
    pinSize: Size;
    pinTopLeft: Point;
    color: string;
    onImageLoad: (size: Size) => void;
    onDragStop: (_e: unknown, data: { x: number; y: number }) => void;
};

export function PinImagePreview({
    src,
    alt,
    imageSize,
    pinSize,
    pinTopLeft,
    color,
    onImageLoad,
    onDragStop
}: PinImagePreviewProps) {
    const isImageLoaded = imageSize.width > 0;

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
                sx={{
                    position: 'relative',
                    display: 'inline-block',
                    lineHeight: 0,
                    overflow: 'hidden',
                    borderRadius: '4px'
                }}
            >
                <Box
                    component="img"
                    src={src}
                    alt={alt}
                    draggable={false}
                    onLoad={function (event: React.SyntheticEvent<HTMLImageElement>) {
                        onImageLoad({
                            width: event.currentTarget.clientWidth,
                            height: event.currentTarget.clientHeight
                        });
                    }}
                    sx={{
                        display: 'block',
                        maxWidth: '100%',
                        maxHeight: '65vh',
                        userSelect: 'none'
                    }}
                />
                {isImageLoaded ? (
                    <Draggable
                        bounds={pinDragBounds(imageSize, pinSize)}
                        position={pinTopLeft}
                        onStop={onDragStop}
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: pinSize.width,
                                height: pinSize.height,
                                lineHeight: 0,
                                cursor: 'grab',
                                userSelect: 'none'
                            }}
                        >
                            <Box
                                component="svg"
                                width={pinSize.width}
                                height={pinSize.height}
                                viewBox={`0 0 ${PIN_VIEWBOX_WIDTH} ${PIN_VIEWBOX_HEIGHT}`}
                                aria-hidden="true"
                                sx={{ display: 'block', overflow: 'visible' }}
                            >
                                <path
                                    d={PIN_PATH}
                                    fill={color}
                                    stroke="#ffffff"
                                    strokeWidth={PIN_STROKE_WIDTH}
                                />
                                <circle
                                    cx={PIN_VIEWBOX_WIDTH / 2}
                                    cy={12}
                                    r={PIN_INNER_CIRCLE_RADIUS}
                                    fill="#ffffff"
                                />
                            </Box>
                        </Box>
                    </Draggable>
                ) : null}
            </Box>
        </Box>
    );
}
